import {Observers, RealtimeMessageModel, SignalRMethod} from "@api/repositories/reatime-repository/types";
import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";
import {Store} from "vuex";
import {parseJson} from "@common/TypesHelper";
import {updateFavoritesAction} from "@service/store/favorites/actions";

export class FavoritesObserver {
    private readonly observers: Observers;
    private readonly schemaId: string;

    constructor(
        private readonly realtimeRepository: RealtimeRepository,
        private readonly store: Store<any>,
    ) {
        this.schemaId = process.env.VUE_APP_AGENDA_SCHEMA as string || 'Agenda';
        this.observers = {
            [this.channelName]: {
                [SignalRMethod.favoritesUpdated]: this.handler.bind(this)
            }
        }
    }

    private get channelName(): string {
        return `objects.${this.schemaId}.${this.store.state.session.language ?? 'en'}`;
    }

    private async handler(data: any): Promise<void> {
        const messageObject = parseJson(data) as RealtimeMessageModel;

        if(!messageObject) {
            return;
        }

        const { objectId, isFavorite } = messageObject;

        await this.store.dispatch(updateFavoritesAction, {
            schemaId: this.schemaId,
            objectId: objectId,
            isFavorite: isFavorite
        })
    }

    async connect() {
        try {
            await this.realtimeRepository.attach(this.observers);
            return true;
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
        return false;
    }

    async disconnect() {
        try {
            await this.realtimeRepository.detach(this.observers);
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
    }
}
